import BaseAPI from './base/base-api';

class NpsAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'ManagementAPI';
	controllerName = 'nps';
}

export default new NpsAPI();
